
import React from "react";

export type LabelTextProps = {
  label: string;
  text: React.ReactNode;
  orientation?: "vertical" | "horizontal";
  size?: "sm" | "md" | "lg";
  className?: string;
  labelClassName?: string;
  textClassName?: string;
};

const sizeClasses = {
  sm: {
    label: "text-xs text-gray-500",
    text: "text-sm text-gray-900 font-medium",
    gap: "gap-1",
  },
  md: {
    label: "text-sm text-gray-500",
    text: "text-base text-gray-900 font-semibold",
    gap: "gap-1.5",
  },
  lg: {
    label: "text-base text-gray-500",
    text: "text-lg text-gray-900 font-bold",
    gap: "gap-2",
  },
};

export default function LabelText({
  label,
  text,
  orientation = "vertical",
  size = "md",
  className = "",
  labelClassName = "",
  textClassName = "",
}: LabelTextProps) {
  const styles = sizeClasses[size];
  return (
    <div
      className={`flex ${
        orientation === "horizontal" ? "flex-row items-center" : "flex-col"
      } ${styles.gap} ${className}`}
    >
      <span className={`${styles.label} ${labelClassName}`}>{label}</span>
      <span className={`${styles.text} ${textClassName}`}>{text}</span>
    </div>
  );
}


